export enum FormFieldTypes {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  CHECKBOX = 'checkbox',
  DATE_PICKER = 'date-picker',
  SELECT = 'select',
  SKELETON = 'skeleton',
  PHONE_INPUT = 'phone-input',
  PHONE_OTP = 'phone-otp',
}

export interface LoadDetails {
  truckType: string;
  itemDescription: string;
  loadType: string;
  temperature: string;
  quantity: number;
  payload: string;
  goodsValue?: number; // Add this field
}

export interface OrderData {
  loadDetails: LoadDetails[];
  customLoadDetails: LoadDetails[];
  pickupDate: {
    from: string;
    to: string;
  };
  priceData: any;
  selectedCustomer?: {
    name: string;
    phone: string;
    type: string;
    _id?: string;
  };
}
